import React from 'react';

function List(props) {
    return (
        <ul className="todo-list">
            {props.itemsList.map((item, index) => (
                <tr>
                    <li key={index}>{item}</li>
                </tr>
            ))}
        </ul>
    )
}

export default List;